export const DEFAULT_MAP_CENTER: [number, number] = [43.238949, 76.889709];
export const DEFAULT_MAP_ZOOM = 13;
